module.exports = __webpack_public_path__ + "static/media/ic_delete_white.908ef6e1.svg";